import React, { memo } from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import {
  LoggedOutFullLibraryData,
  LoggedOutProductLibraryContainsItem,
} from '../../types/library';
import L1Item from './logged-out/L1Item';

type Props = {
  library: LoggedOutFullLibraryData;
  targetId?: string;
};

/**
 * LibraryTopicBoxLoggedOut.
 */
const LibraryTopicBoxLoggedOut = (props: Props) => {
  const { library, targetId } = props;
  const subjects = library.productLibrary;

  // Flatten grouped and ungrouped subjects into a single ordered list of L1
  // items so the logged-out trial CTA can be rendered once, after the first L3
  // of the first L2 of the first L1, regardless of whether the first subject is
  // a group. The `showCta` flag is threaded down through L1Item -> L2Item.
  const l1Items: {
    l1: LoggedOutProductLibraryContainsItem;
    groupName?: string;
  }[] = subjects.flatMap((l1) =>
    'groupName' in l1
      ? l1.navs.map((l1Item) => ({ l1: l1Item, groupName: l1.groupName || '' }))
      : [{ l1: l1 as LoggedOutProductLibraryContainsItem }],
  );

  return (
    <Box ml={[0, 2, 0]} data-testid="container">
      {l1Items.map(({ l1, groupName }, index) => (
        <L1Item
          key={l1.id}
          l1={l1}
          {...(groupName !== undefined && { groupName })}
          {...(targetId && { targetId })}
          showCta={index === 0}
        />
      ))}
    </Box>
  );
};

export default memo(LibraryTopicBoxLoggedOut);
